// src/components/Impressum.js
import React from "react";
import Layout from "./../components/layout";
import "./Legal.css";

const Impressum = () => {
  return (
    <Layout>
      <div className="Top">
        <div className="legal-container">
          <h1 className="legal-title">Impressum</h1>
          <h2>Angaben gemäß § 5 TMG</h2>
          <br />
          <h3>Verantwortlich für den Inhalt:</h3>
          <p>
            Menu-Software.de
            <br />
            Entwicklung im Auftrag von Moon Lounge
            <br />
            <br />
            Auftraggeber: Moon Lounge <br/>Furtstraße 4, 73770 Denkendorf, Deutschland

          </p>
          <h2>Kontakt</h2>
          <p>
  E-Mail: <a href="mailto:Kontakt@Moon-Lounge.de">Kontakt@Moon-Lounge.de</a>
</p>

          <h2>Haftungsausschluss</h2>
          <h3>Haftung für Inhalte</h3>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
            auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
            §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
            überwachen oder nach Umständen zu forschen, die auf eine
            rechtswidrige Tätigkeit hinweisen.
          </p>
          <h3>Haftung für Links</h3>
          <p>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Impressum;
